import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M20.636 9.964L18 7.793V6.707C18 6.44 17.896 6.189 17.707 6L15 3.293C14.812 3.104 14.56 3 14.293 3H7C6.449 3 6 3.449 6 4V7.793L3.365 9.963C3.133 10.154 3 10.436 3 10.736V20C3 20.552 3.449 21 4 21H20C20.552 21 21 20.552 21 20V10.736C21 10.436 20.867 10.154 20.636 9.964ZM19.73 10.513L18 12.039V9.089L19.73 10.513ZM7 4H14.293L17 6.707V12.779L12 17.324L7 12.779V4ZM6 12.039L4.271 10.513L6 9.089V12.039V12.039ZM4 20V11.608L11.338 18.083C11.526 18.249 11.763 18.332 12 18.332C12.237 18.332 12.473 18.249 12.662 18.083L20.001 11.608L20 20H4V20Z"
      fill="currentColor"
    />
    <path d="M9 7H15V8H9V7Z" fill="currentColor" />
    <path d="M9 9H15V10H9V9Z" fill="currentColor" />
    <path d="M9 11H15V12H9V11Z" fill="currentColor" />
  </>
);

const Icon = createSvgIcon(svg, 'EnvelopeLetter');

export default Icon;
